/* eslint-disable react/jsx-props-no-spreading */
import { BubbleStyleType } from '@/types/BubbleStyleType';
import { getGradientByColor } from '@/utils/color';
import cn from '@/utils/cn';
import { BubbleModeEnum } from '@/enum/BubbleModeEnum';
import { BubbleShapeEnum } from '@/enum/BubbleShapeEnum';
import type { CSSProperties } from 'react';
import React from 'react';
import styles from './Blob.module.css';

interface BlobProps {
  children: React.ReactNode;
  shape: BubbleStyleType['shape'];
  theme: BubbleStyleType['theme'];
  color: BubbleStyleType['color'];
  mode: BubbleStyleType['mode'];
  className?: string;
  style?: CSSProperties;
  /** Attributs `data-*` à ajouter sur le div root (ex. data-bubble-anchor pour BackgroundBubble). */
  wrapperProps?: Record<`data-${string}`, string | undefined>;
  /**
   * Si false, n'ajoute pas `data-blob-shape` (quand le parent est déjà la plateforme).
   * @default true
   */
  asPlatform?: boolean;
}

function Blob({
  children,
  shape,
  theme,
  color,
  mode,
  className,
  style,
  wrapperProps,
  asPlatform = true,
}: BlobProps) {
  const gradient = theme || getGradientByColor(color);

  return (
    <div
      className={cn([
        styles.blob,
        styles[shape ?? BubbleShapeEnum.SHAPE_1],
        styles[mode ?? BubbleModeEnum.WRAPPED],
        className,
      ])}
      style={
        {
          ...style,
          '--gradient-start': gradient?.start,
          '--gradient-end': gradient?.end,
        } as CSSProperties
      }
      data-blob-shape={asPlatform ? (shape ?? undefined) : undefined}
      {...wrapperProps}
    >
      {children}
    </div>
  );
}

export default Blob;
